import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const PageLinkContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const PageLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;
  width: 30px;
  margin-right: 3px;
  background: ${props => props.selected ? '#e8e8e8' : 'white'};
  color: ${props => props.selected ? '#b4b5b6' : '#444'};
  &:hover {
    background: #dbdbdc;
  }
`
const NavButton = styled.div`
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0px 5px;
  background: #75AFB6;
  margin-right: 3px;
  &:hover {
    background: #569aa2;
  }
`
const Ellipsis = styled.div`
  display: flex;
  align-items: flex-end;
  width: 30px;
  padding: 5px;
`

const PageLinks = ({ currentPage, totalPages, changePage, next, last, first, prev }) => {
  // Render links for the prior 3 pages and the next four pages, in addition to the current page
  // const maxPages = 8
  const earliestPage = currentPage - 4
  const pages = [...Array(totalPages).keys()].map(n => n + 1)
  const right = pages.slice(currentPage, currentPage + 4)
  const left = pages.slice(earliestPage > 0 ? earliestPage : 0, currentPage)
  const lastPage = right[right.length - 1]
  const shownPages = left.concat(right)
  const pageLinks = shownPages.map(pageNumber => {
    return (
      <PageLink key={`page-${pageNumber}`} selected={pageNumber === currentPage} onClick={() => changePage(pageNumber)}>
        {pageNumber}
      </PageLink>
    )
  })
  const prevLinks = (
    <Fragment>
      <NavButton onClick={first}>
        &laquo; First
      </NavButton>
      <NavButton onClick={prev}>
        &lsaquo; Prev
      </NavButton>
    </Fragment>
  )
  const nextLinks = (
    <Fragment>
      <NavButton onClick={next}>
        Next &rsaquo;
      </NavButton>
      <NavButton onClick={last}>
        Last &raquo;
      </NavButton>
    </Fragment>
  )
  return (
    <PageLinkContainer>
      {currentPage > 1 ? prevLinks : null}
      {pageLinks}
      {lastPage < totalPages ? <Ellipsis key="page-ellipsis">...</Ellipsis> : null}
      {currentPage !== totalPages ? nextLinks : null}
    </PageLinkContainer>
  )
}

PageLinks.displayName = 'PageLinks'

PageLinks.propTypes = {
  changePage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  first: PropTypes.func.isRequired,
  last: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired
}

export default PageLinks
